import React from "react";
import { FaCreditCard, FaCheck, FaTimes, FaExclamationCircle, FaExternalLinkAlt } from "react-icons/fa";

const PaymentSection = ({ profileData, isSaving, handleStripeConnect }) => {
  const stripeConnected = Boolean(profileData?.stripeAccountId);
  const stripeStatus = profileData?.stripeStatus || "not_connected";

  const statusConfig = {
    verified: { label: "Connected", bg: "bg-green-50", text: "text-green-700", border: "border-green-200", icon: <FaCheck className="mr-1.5" /> },
    pending: { label: "Connected", bg: "bg-green-50", text: "text-green-700", border: "border-green-200", icon: <FaCheck className="mr-1.5" /> },
    not_connected: { label: "Not Connected", bg: "bg-red-50", text: "text-red-700", border: "border-red-200", icon: <FaTimes className="mr-1.5" /> },
  };

  const currentStatus = statusConfig[stripeStatus] || statusConfig.not_connected;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold text-gray-800 flex items-center">
          <FaCreditCard className="text-blue-600 mr-3" /> Payment Settings
        </h2>
        <span className={`flex items-center ${currentStatus.bg} ${currentStatus.text} px-3 py-1.5 rounded-lg text-sm font-medium border ${currentStatus.border}`}>
          {currentStatus.icon} {currentStatus.label}
        </span>
      </div>

      <div className={`p-5 border border-gray-200 rounded-lg ${stripeConnected ? 'bg-gray-50' : 'bg-white text-center'}`}>
        {stripeConnected ? (
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <p className="text-gray-800 font-medium mb-1">Stripe Account ID</p>
              <p className="text-blue-600 font-mono text-sm mb-2">
                {profileData.stripeAccountId?.slice(0, 8)}•••••
              </p>
            </div>
            <button
              type="button"
              onClick={() => handleStripeConnect(true)}
              disabled={isSaving}
              className="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors flex items-center disabled:opacity-70"
            >
              {isSaving ? <Spinner /> : "Update Account"}
            </button>
          </div>
        ) : (
          <>
            <p className="text-gray-700 mb-4">Connect your Stripe account to receive payments securely.</p>
            <button
              type="button"
              onClick={() => handleStripeConnect(false)}
              disabled={isSaving}
              className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors disabled:opacity-70"
            >
              {isSaving ? <Spinner /> : "Connect with Stripe"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

const Spinner = () => (
  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2 inline-block"></div>
);

export default PaymentSection;